<!-- Auth Dialogs Component - Available globally -->
<app-auth-dialogs></app-auth-dialogs>

<router-outlet></router-outlet>
<div class="np-loader" *ngIf="showLoader">
  <p-progressSpinner strokeWidth="5"></p-progressSpinner>
</div>
